<template>
  <div>
    <Widget>
      <div style="background: #eaf0f6; border-radius: 0.5rem; padding: 1rem">
        <b-form>
          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="d-flex justify-content-between align-items-center">
                <span class="fw-bold">
                  Surat Permohonan Pengembalian/Perubahan
                </span>
                <b-button
                  variant="success"
                  :href="form.file_permohonan_pemuktahiran"
                  target="_blank"
                  class="text-white m-1"
                >
                  <i class="fa fa-download"></i> Unduh
                </b-button>
              </div>
            </div>
            <div class="w-100"></div>
            <div class="col-lg-4 mb-3">
              <label for="nomor_surat_permohonan">
                Nomor Surat <span class="text-danger">*</span>
              </label>
              <b-form-input
                id="nomor_surat_permohonan"
                v-model="form.nomor_surat_permohonan"
                v-validate="'required'"
                name="Nomor Surat"
                style="opacity: 0.7"
                disabled
              ></b-form-input>
            </div>
            <div class="col-lg-4 mb-3">
              <label for="perihal_surat_permohonan">
                Perihal Surat <span class="text-danger">*</span>
              </label>
              <b-form-input
                id="perihal_surat_permohonan"
                v-model="form.perihal_surat_permohonan"
                v-validate="'required'"
                name="Perihal Surat"
                style="opacity: 0.7"
                disabled
              ></b-form-input>
            </div>
            <div class="col-lg-4 mb-3">
              <label for="tanggal_surat_permohonan">
                Tanggal Surat <span class="text-danger">*</span>
              </label>
              <b-form-input
                type="date"
                id="tanggal_surat_permohonan"
                v-model="form.tanggal_surat_permohonan"
                v-validate="'required'"
                name="Tanggal Surat"
                style="opacity: 0.7"
                disabled
              ></b-form-input>
            </div>
          </div>
          <div class="mb-3" style="border-bottom: 1px solid black"></div>

          <div class="row mb-3">
            <div class="col-md-6 mb-3">
              <label for="jenis_pemuktahiran">Jenis Pemutakhiran</label>
              <v-select
                id="jenis_pemuktahiran"
                v-model="form.jenis_pemuktahiran"
                :options="['Pengembalian', 'Perubahan']"
                name="Jenis Pemutakhiran"
                v-validate="'required'"
                style="opacity: 0.7"
                disabled
              />
            </div>
            <div class="col-md-6 mb-3">
              <label for="jenis_permohonan">Jenis Permohonan</label>
              <v-select
                id="jenis_permohonan"
                v-model="form.jenis_permohonan"
                :options="['Berusaha', 'Non Berusaha']"
                name="Jenis Permohonan"
                v-validate="'required'"
                style="opacity: 0.7"
                disabled
              />
            </div>
            <div class="col-md-6 mb-3">
              <label for="nomor_izin_terbit">Nomor Penerbitan Izin</label>
              <b-form-input
                id="nomor_izin_terbit"
                v-model="form.nomor_izin_terbit"
                v-validate="'required'"
                name="Nomor Penerbitan Izin"
                style="opacity: 0.7"
                disabled
              ></b-form-input>
            </div>
            <div class="col-md-6 mb-3">
              <label for="instansi_pemohon">Instansi Pemohon</label>
              <b-form-input
                id="instansi_pemohon"
                v-model="form.instansi_pemohon"
                v-validate="'required'"
                name="Instansi Pemohon"
                style="opacity: 0.7"
                disabled
              ></b-form-input>
            </div>
            <div
              v-if="form.jenis_permohonan === 'Berusaha'"
              class="col-md-6 mb-3"
            >
              <label for="nib">NIB</label>
              <b-form-input
                id="nib"
                v-model="form.nib"
                v-validate="'required'"
                name="NIB"
                style="opacity: 0.7"
                disabled
              ></b-form-input>
            </div>
            <div class="col-md-6 mb-3">
              <label for="nomor_permohonan">Nomor Permohonan</label>
              <b-form-input
                id="nomor_permohonan"
                v-model="form.nomor_permohonan"
                v-validate="'required'"
                name="Nomor Permohonan"
                style="opacity: 0.7"
                disabled
              ></b-form-input>
            </div>
            <div class="col-md-6 mb-3">
              <label for="npwp">NPWP</label>
              <b-form-input
                id="npwp"
                v-model="form.npwp"
                v-mask="'##.###.###.#-###.####'"
                v-validate="'required'"
                name="NPWP"
                style="opacity: 0.7"
                disabled
              ></b-form-input>
            </div>
            <div class="col-md-6 mb-3">
              <label for="tanggal_penerbitan_izin">Tanggal Penerbitan</label>
              <b-form-input
                type="date"
                id="tanggal_penerbitan_izin"
                v-model="form.tanggal_penerbitan_izin"
                v-validate="'required'"
                name="Tanggal Penerbitan"
                style="opacity: 0.7"
                disabled
              ></b-form-input>
            </div>
            <div class="col-12 mb-3">
              <label for="alasan_pemuktahiran">Alasan Pemutakhiran</label>
              <div style="opacity: 0.7">
                <ckeditor
                  id="alasan_pemuktahiran"
                  v-model="form.alasan_pemuktahiran"
                  :editor="wygEditor"
                  disabled
                ></ckeditor>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <div class="d-flex justify-content-between align-items-center">
                <span class="fw-bold"> Dokumen Pendukung Lainnya </span>
                <b-button
                  variant="success"
                  :href="form.file_dokumen_pendukung"
                  target="_blank"
                  class="text-white m-1"
                  :disabled="!form.file_dokumen_pendukung"
                >
                  <i class="fa fa-download"></i> Unduh
                </b-button>
              </div>
            </div>
          </div>
          <legend><strong>Identitas Penanggung Jawab</strong></legend>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="nama_penanggungjawab">Nama Penanggung Jawab</label>
              <b-form-input
                id="nama_penanggungjawab"
                v-model="form.nama_penanggungjawab"
                v-validate="'required'"
                name="Nama Penanggung Jawab"
                style="opacity: 0.7"
                disabled
              ></b-form-input>
            </div>
            <div class="col-md-6 mb-3">
              <label for="jabatan_penanggungjawab">
                Jabatan Penanggung Jawab
              </label>
              <b-form-input
                id="jabatan_penanggungjawab"
                v-model="form.jabatan_penanggungjawab"
                v-validate="'required'"
                name="Jabatan Penanggung Jawab"
                style="opacity: 0.7"
                disabled
              ></b-form-input>
            </div>
            <div class="col-md-6 mb-3">
              <label for="no_telepon_penanggungjawab">
                Nomor Telepon Seluler
              </label>
              <b-form-input
                id="no_telepon_penanggungjawab"
                v-model="form.no_telepon_penanggungjawab"
                v-validate="'required'"
                name="Nomor Telepon Seluler"
                style="opacity: 0.7"
                disabled
              ></b-form-input>
            </div>
            <div class="col-12">
              <div class="my-2" style="border-bottom: 1px solid black"></div>
            </div>
            <div class="col-12 mb-3">
              <label for="catatan_penolakan_pemuktahiran">
                Catatan (apabila tidak diterima)
              </label>
              <ckeditor
                id="catatan_penolakan_pemuktahiran"
                v-model="formVerifikasi.catatan_penolakan_pemuktahiran"
                :editor="wygEditor"
              ></ckeditor>
              <span class="text-danger" v-if="errors.has('Catatan Penolakan')">
                {{ errors.first('Catatan Penolakan') }}
              </span>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <b-button
              variant="danger"
              class="text-white m-1"
              @click="$router.push('/app/pembatalan')"
            >
              Kembali
            </b-button>
            <b-button
              variant="primary"
              class="text-white m-1"
              @click="$bvModal.show('modal-verifikasi')"
            >
              Verifikasi
            </b-button>
          </div>
        </b-form>
      </div>
    </Widget>

    <b-modal
      id="modal-verifikasi"
      title="Verifikasi Pembatalan"
      size="sm"
      centered
    >
      <div class="d-flex justify-content-between">
        <b-button
          variant="primary"
          class="text-white m-1"
          @click="submitForm('Terima')"
        >
          Terima
        </b-button>
        <b-button
          variant="danger"
          class="text-white m-1"
          @click="submitForm('Tolak')"
        >
          Tolak
        </b-button>
        <b-button
          variant="secondary"
          class="text-white m-1"
          @click="$bvModal.hide('modal-verifikasi')"
        >
          Batal
        </b-button>
      </div>
      <template #modal-footer>
        <div></div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget.vue'
import { Validator } from 'vee-validate'
import vSelect from 'vue-select'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  components: { Widget, vSelect },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      wygEditor: ClassicEditor,
      form: {
        file_permohonan_pemuktahiran: null,
        nomor_surat_permohonan: null,
        perihal_surat_permohonan: null,
        tanggal_surat_permohonan: null,
        jenis_pemuktahiran: null,
        jenis_permohonan: null,
        nomor_izin_terbit: null,
        instansi_pemohon: null,
        nib: null,
        npwp: null,
        nomor_permohonan: null,
        tanggal_penerbitan_izin: null,
        alasan_pemuktahiran: null,
        file_dokumen_pendukung: null,
        nama_penanggungjawab: null,
        jabatan_penanggungjawab: null,
        no_telepon_penanggungjawab: null,
      },
      formVerifikasi: {
        catatan_penolakan_pemuktahiran: null,
        status_persetujuan: null,
      },
    }
  },
  methods: {
    async loadData() {
      const id = this.$route.query.id_pemutakhiran
      if (!id) {
        this.$router.push('/app/pembatalan')
        return
      }

      const res = await axios.get(
        `${this.baseapi}api/pemuktahiran/${id}`,
        this.getApiOption(),
      )
      const resData = res.data.data
      for (const k in this.form) {
        this.form[k] = resData[k]
      }
      if (resData.catatan_penolakan_pemuktahiran) {
        this.formVerifikasi.catatan_penolakan_pemuktahiran =
          resData.catatan_penolakan_pemuktahiran
      }
    },

    async submitForm(status) {
      const confirm = await Swal.fire({
        title: 'Apakah Anda yakin?',
        text:
          status === 'Tolak'
            ? 'Tolak permohonan pembatalan'
            : 'Terima permohonan pembatalan',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Batal',
      })
      this.$bvModal.hide('modal-verifikasi')
      if (!confirm.isConfirmed) return

      if (status === 'Tolak') {
        this.manualValidation(
          this.formVerifikasi.catatan_penolakan_pemuktahiran,
          'Catatan Penolakan',
          'Catatan Penolakan wajib diisi apabila permohonan ditolak',
        )
      }

      await this.$validator.validateAll()
      if (this.$validator.errors.items.length) {
        Swal.fire(
          '',
          'Catatan Penolakan wajib diisi apabila permohonan ditolak',
          'warning',
        )
        return
      }

      this.$loading(true)
      const formData = {
        status_persetujuan: status,
      }
      if (status === 'Tolak') {
        formData.catatan_penolakan_pemuktahiran =
          this.formVerifikasi.catatan_penolakan_pemuktahiran
      }

      const id = this.$route.query.id_pemutakhiran
      try {
        await axios.post(
          `${this.baseapi}api/pemuktahiran/setPersetujuan/${id}`,
          formData,
          this.getApiOption(),
        )
        await axios.post(
          `${this.baseapi}api/pemuktahiran/${id}`,
          {
            status:
              status === 'Terima' ? 'Menunggu Jadwal Penilaian' : 'Perbaikan',
          },
          this.getApiOption(),
        )
        Swal.fire(
          'Berhasil',
          'Berhasil verifikasi permohonan pembatalan',
          'success',
        )
        this.$router.push('/app/pembatalan')
      } catch (error) {
        Swal.fire('Gagal', 'Gagal verifikasi permohonan pembatalan', 'error')
      }
      this.$loading(false)
    },

    manualValidation(field, name, msg) {
      if (!field) {
        this.$validator.errors.add({
          field: name,
          msg: msg,
        })
        return false
      } else {
        return true
      }
    },

    manualRemoveError(name) {
      this.$validator.errors.remove(name)
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },
  },
  watch: {
    'formVerifikasi.catatan_penolakan_pemuktahiran'() {
      this.manualRemoveError('Catatan Penolakan')
    },
  },
  mounted() {
    this.loadData()
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
}
</script>
